import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { BudgetCalculator } from '@ramsey-plus-calculators/budget-calculator';
import onReady from './utils/onReady';
import '@ramsey-plus-calculators/budget-calculator/dist/budget-calculator.cjs.production.min.css';

onReady(() => {
  const budgetCalculatorRoot = document.querySelector('#budget_calculator');
  const budgetCalculatorProps = window.budgetCalculatorProps || {};

  ReactDOM.render(
    <BudgetCalculator {...budgetCalculatorProps} />,
    budgetCalculatorRoot
  );
});
